/**
 * Validate for Unique ID and Plan Id; must be numeric
 * @param value
 * @returns
 */
export const validId = (value: string) => {
    return value.match(/^[0-9]+$/) !== null;
};
